import React from "react";
import './About.css'
import '../../Styles/Page.css'
const About = () => {
    return <div className="About" id="page">  
      About Route
    </div>;
  }
  
export default About;